//------------------------------------------------------------------------------
// must be imported as a module
//------------------------------------------------------------------------------
// Import Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";

// Optional: import Bootstrap JS if needed (e.g., modals, dropdowns)
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import "bootstrap-icons/font/bootstrap-icons.css";
//------------------------------------------------------------------------------
/*
import shareImage from "./img/marinaSunset_Edmonds.jpg";

const meta = document.createElement("meta");
meta.setAttribute("property", "og:image");
meta.setAttribute("content", shareImage);
document.head.appendChild(meta);
console.log("*** shareImage=", shareImage);
*/
//------------------------------------------------------------------------------
